import React, { useState } from "react";
import "../css/form.css";

export default function ItemAdd() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

    // Authentication state
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState("");  
    const CORRECT_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;

     // form state
    const [form, setForm] = useState({
    workshopLocation: "",
    firstName: "",
    location: "",
    imageUrl: "",
    imageFile: null,
    imagePreview: ""
});
//Commenting out file upload for 1/31 test
//const [uploadMethod, setUploadMethod] = useState("url"); // "url" or "file"

const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
};

//Commenting out file upload for 1/31 test
/*
const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) {
        setForm((f) => ({ ...f, imageFile: null, imagePreview: "" }));
        return;
    }
    const reader = new FileReader();
    reader.onload = () => {
        setForm((f) => ({ ...f, imageFile: file, imagePreview: reader.result }));
    };
    reader.readAsDataURL(file);
};
*/

const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        let response;
        /* Commenting out file upload for 1/31 test
        
        if (uploadMethod === "file" && form.imageFile) {
            // Upload file using FormData
            const formData = new FormData();
            formData.append('workshopLocation', form.workshopLocation);
            formData.append('name', form.name);
            formData.append('location', form.location);
            formData.append('title', form.title);
            formData.append('description', form.description);
            formData.append('image', form.imageFile);

            response = await fetch(`${BACKEND_URL}/add-item`, {
                method: "POST",
                body: formData,
            });
        } 
            */
          // else {
            // Send URL as JSON

            response = await fetch(`${BACKEND_URL}/add-item`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
             body: JSON.stringify({
    workshopLocation: form.workshopLocation,
    firstName: form.firstName,  // ✅ Sending as 'firstName'
    location: form.location,
    imageUrl: form.imageUrl
}),
            });
       // }

        if (!response.ok) {
            const text = await response.text();
            console.error('Server response:', text);
            throw new Error(`Server error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        
        if (data.status === "success") {
            alert("Item added successfully!");
            setForm({ 
                workshopLocation: "Main Branch 1/31/26",
                name: "", 
                location: "", 
                imageUrl: "",
                imageFile: null,
                imagePreview: ""
            });
        } else {
            alert("Failed to add item: " + data.message);
        }
    } catch (err) {
        console.error(err);
        alert("Error submitting form: " + err.message);
    }
};
const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
        setIsAuthenticated(true);
    } else {
        alert("Incorrect password");
        setPassword("");
    }
};
if (!isAuthenticated) { 
        return (

<div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: "white",
                padding: "2em",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                minWidth: "300px"
            }}>
                <h2 style={{ marginTop: 0, textAlign: "center" }}>Admin Access</h2>
                <form onSubmit={handlePasswordSubmit}>
                    <div style={{ marginBottom: "1em" }}>
                        <label style={{ display: "block", marginBottom: "0.5em" }}>
                            Enter Password:
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "0.5em",
                                borderRadius: "4px",
                                border: "1px solid #ccc"
                            }}
                            autoFocus
                            required
                        />
                    </div>
                    <button 
                        type="submit"
                        style={{
                            width: "100%",
                            padding: "0.75em",
                            backgroundColor: "#f08c04",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "1em"
                        }}
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
}

    return (
        <form onSubmit={handleSubmit} style={{    display: "flex", flexDirection: "column", alignItems: "center",    marginTop: "2em"}}>
            <table style={{ borderCollapse: "collapse", backgroundColor: " #f08c048c;", borderRadius: "24px"}}>
                <tbody>
                          <tr>
                        <th className="formHead" style={{ textAlign: "left", padding: 16 }}>Workshop Location </th>
                        <td style={{ padding: 16 }}>
<select name="workshopLocation" value={form.workshopLocation} onChange={handleChange} required>
    <option value="">-- Select Location --</option>
                    <option value="Photo Walk 05/15/26">Photo Walk 05/15/26</option>
                <option value="Book Odes 05/02/26">Book Odes 05/02/26</option>
            <option value="O, Miami 04/09/26">O Miami 04/09/26</option>
        <option value="Vizcaya Museum and Gardens 3/29/26">Vizcaya Museum and Gardens 3/29/26</option>
    <option value="Main Branch 1/31/26">Main Branch 1/31/26</option>
    <option value="Bass Museum Pilot (2023)">Bass Museum Pilot (2023)</option>
</select>
                        </td>
                    </tr>
                    <tr>
                        <th className="formHead" style={{ textAlign: "left", padding: 16 }}>Name</th>
                        <td style={{ padding: 16 }}>
                            <input
                                name="firstName"
                                value={form.firstName}
                                onChange={handleChange}
                                required
                            />
                        </td>
                    </tr>

                    <tr>
                        <th className="formHead" style={{ textAlign: "left", padding: 16 }}>Location</th>
                        <td style={{ padding: 16 }}>
                            <input
                                name="location"
                                value={form.location}
                                onChange={handleChange}
                            />
                        </td>
                    </tr>

        


                    <tr>
    <th className="formHead" style={{ textAlign: "left", padding: 16 }}>Image</th>
    <td style={{ padding: 16 }}>
        {/* Toggle between URL and File upload, But commenting out for 1/31 test */}
         {/*
        <div style={{ marginBottom: 12 }}>
           
            }<label style={{ marginRight: 16 }}>
                <input 
                    type="radio" 
                    name="uploadMethod" 
                    value="url"
                    checked={uploadMethod === "url"}
                    onChange={(e) => setUploadMethod(e.target.value)}
                />
                {' '}Image URL
            </label>
            <label>
                <input 
                    type="radio" 
                    name="uploadMethod" 
                    value="file"
                    checked={uploadMethod === "file"}
                    onChange={(e) => setUploadMethod(e.target.value)}
                />
                {' '}Upload FILE
            </label>
         
        </div>
   */}
       <div>
                <input
                    name="imageUrl"
                    type="url"
                    value={form.imageUrl}
                    onChange={handleChange}
                    placeholder="https://example.com/image.jpg"
                    style={{ width: '100%' }}
                />
                {form.imageUrl && (
                    <div style={{ marginTop: 16 }}>
                        <img
                            src={form.imageUrl}
                            alt="preview"
                            style={{ maxWidth: "150px", maxHeight: "150px", display: "block" }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                        />
                    </div>
                )}
            </div>
        
    </td>
</tr>

                    <tr>
                        <td colSpan="2" style={{ padding: 16, textAlign: "center" }}>
                            <button type="submit">Add</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    );
}